import { jsx } from "react/jsx-runtime";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import { validateTidalLicense } from "../../base/index.js";
function ChatBubble(props) {
  return /* @__PURE__ */ jsx(
    ChatBubbleIcon,
    {
      "data-testid": "ChatBubble",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ChatBubble",
      "data-tidal-icon-meta": "chat,customerService"
    }
  );
}
ChatBubble.tidalIconMeta = {
  categories: "chat,customerService",
  name: "ChatBubble"
};
validateTidalLicense();
export {
  ChatBubble
};
//# sourceMappingURL=ChatBubble.js.map
